import { Uint128SafeIntegerOverflowError } from "./errors.js";

/**
 * Convert Uint128 to number (warns on overflow)
 *
 * @see https://voltaire.tevm.sh/primitives/uint128 for Uint128 documentation
 * @since 0.0.0
 * @param {import('./Uint128Type.js').Uint128Type} uint - Uint128 value
 * @returns {number} Number value
 * @throws {Uint128SafeIntegerOverflowError} If value exceeds Number.MAX_SAFE_INTEGER
 * @example
 * ```javascript
 * import * as Uint128 from './primitives/Uint128/index.js';
 * const value = Uint128.from(255n);
 * const num = Uint128.toNumber(value); // 255
 * ```
 */
export function toNumber(uint) {
	if (uint > Number.MAX_SAFE_INTEGER) {
		throw new Uint128SafeIntegerOverflowError(
			`Uint128 value ${uint} exceeds Number.MAX_SAFE_INTEGER (${Number.MAX_SAFE_INTEGER})`,
			{ value: uint },
		);
	}
	return Number(uint);
}
